import { Theme } from '@mui/material/styles'
import { RadioProps } from '@mui/material/Radio'
//
import { RadioIcon, RadioCheckedIcon } from './CustomIcons'

// ----------------------------------------------------------------------

export default function Radio(theme: Theme) {
  return {
    MuiRadio: {
      defaultProps: {
        icon: <RadioIcon />,
        checkedIcon: <RadioCheckedIcon />,
      },

      styleOverrides: {
        root: ({ ownerState }: { ownerState: RadioProps }) => ({
          padding: theme.spacing(1),
          // On-state is ink, never amber: amber is 1.54:1 on white and fails
          // the 3:1 control-boundary rule — amber means action, not state.
          // :not(.Mui-disabled) keeps MUI's disabled styling winning, so a
          // disabled checked control still reads as disabled.
          '&.Mui-checked:not(.Mui-disabled)': {
            color: theme.palette.text.primary,
          },
          ...(ownerState.size === 'small' && {
            '& svg': { width: 20, height: 20 },
          }),
          ...(ownerState.size === 'medium' && {
            '& svg': { width: 24, height: 24 },
          }),
        }),
      },
    },
  }
}
